import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import React, { Dispatch, SetStateAction } from 'react'
import { Control, UseFormHandleSubmit, FieldValues, UseFormRegister, FieldErrors } from "react-hook-form";
import WSTextField, { CurrencyType, TextType } from '../../Components/TextBox/WSTextBox'
import WSSelectField from '../../Components/Select/WSSelect'
import WSButton from '../../Components/Button/WSButton'
import dayjs from 'dayjs'
import WSDateField from '../../Components/DateField/WSDateField';
import config from '../../Config/clientConfig.json';
import { EmiFormValues } from './LoanDetail';

interface EmiDialogProps {
    selectedEmi: any;
    openPayDialog: boolean;
    setOpenPayDialog: Dispatch<SetStateAction<boolean>>;
    handleConfirmPayment: (data: EmiFormValues) => void;
    emiData: any;
    control: Control<EmiFormValues>;
    handleSubmit: UseFormHandleSubmit<EmiFormValues>;
    submitting: boolean;
}

const EmiDialog: React.FC<EmiDialogProps> = ({ submitting, selectedEmi, emiData, openPayDialog, setOpenPayDialog, handleConfirmPayment, handleSubmit, control }) => {
    console.log('selectedEmi in EmiDialog:', selectedEmi);
    return (
        <Dialog open={openPayDialog} onClose={() => setOpenPayDialog(false)} maxWidth="xs" fullWidth>
            <form onSubmit={handleSubmit((data: any) => handleConfirmPayment(data))}>
                <DialogTitle>Pay EMI for {dayjs(new Date(selectedEmi?.dueDate)).format("MM/DD/YYYY")}</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" mb={2}>
                        EMI Due: ₹{Number(selectedEmi?.emiAmount).toLocaleString()}
                    </Typography>
                    {/* Title */}
                    <Grid
                        item
                        container
                        spacing={1}
                        justifyContent={"start"}
                        sx={{
                            marginTop: 0,
                            marginLeft: 0,
                            width: "100%",
                            backgroundColor: "#4DD26B",
                            borderTopLeftRadius: 5,
                            borderTopRightRadius: 5
                        }}
                    >
                        <Grid
                            alignContent={"center"}
                            style={{ paddingLeft: 20, paddingTop: 0, height: "3rem" }}
                            item
                            sm={4}
                            className="ws-data-grid-lightviolet-title"
                        >
                            <Typography sx={{ fontSize: "14px" }} id="tableTitle" color={"white"}>
                                Make Payment
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Form Body */}
                    <Grid
                        sx={{
                            padding: 3,
                            backgroundColor: "#fff",
                            borderBottomLeftRadius: 5,
                            borderBottomRightRadius: 5,
                            border: "1px solid lightgrey"
                        }}
                    >
                        <Grid container spacing={2}>
                            {/* Repayment Date */}
                            <Grid item xs={12} sm={6}>
                                <WSDateField
                                    id="repaymentDate"
                                    label="Repayment Date"
                                    name="repaymentDate"
                                    control={control}
                                    // defaultValue={new Date()}
                                    rules={{ required: true }}
                                />
                            </Grid>

                            {/* Receipt Number */}
                            <Grid item xs={12} sm={6}>
                                <WSTextField
                                    id="receiptNumber"
                                    label="Receipt Number"
                                    name="receiptNumber"
                                    control={control}
                                    rules={{ required: true }}
                                />
                            </Grid>

                            {/* Amount */}
                            <Grid item xs={12} sm={6}>
                                <WSTextField
                                    id="amount"
                                    label="Amount"
                                    name="amount"
                                    type={TextType.Currency}
                                    currency={CurrencyType.Rupee}
                                    control={control}
                                    rules={{
                                        required: 'Amount is required',
                                        max: {
                                            value: emiData.totalPayment,
                                            message: `Amount cannot exceed ₹${emiData.totalPayment}`
                                        }
                                    }}
                                />
                            </Grid>


                            {/* payment type */}
                            <Grid item xs={12} sm={6}>
                                <WSSelectField
                                    id="paymentType"
                                    label="Payment Type"
                                    name="paymentType"
                                    options={config.paymentMethodConfig.staticOptionData}
                                    defaultValue={config.paymentMethodConfig.staticOptionData[1].value}
                                    control={control}
                                    rules={{ required: true }}
                                />
                            </Grid>

                            {/* Principal Component */}
                            {/* <Grid item xs={12} sm={6}>
                                <WSTextField
                                    id="principal"
                                    label="Principal Component"
                                    name="principal"
                                    type={TextType.Currency}
                                    currency={CurrencyType.Rupee}
                                    control={control}
                                disabled
                                />
                            </Grid> */}

                            {/* Interest Component */}
                            {/* <Grid item xs={12} sm={6}>
                                <WSTextField
                                    id="interestRate"
                                    label="Interest Component"
                                    name="interestRate"
                                    type={TextType.Currency}
                                    currency={CurrencyType.Rupee}
                                    control={control}

                                disabled
                                />
                            </Grid> */}

                            {/* Remarks */}
                            <Grid item xs={12} sm={12}>
                                <WSTextField
                                    id="remarks"
                                    label="Remarks"
                                    name="remarks"
                                    control={control}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Typography variant="caption" color="text.secondary">
                        You can make full or partial payments.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <WSButton id="cancelBtn" size="small" label="Cancel" color="secondary" variant="outlined" onClick={() => setOpenPayDialog(false)} />
                    <WSButton
                        id="paymentBtn"
                        size="small"
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={submitting}
                        label="Confirm Payment"
                    />
                </DialogActions>
            </form>
        </Dialog>
    )
}

export default EmiDialog